import AuthService from "@/services/AuthService";

export default {
  namespaced: true,
  state: () => ({
    isLoggedIn: false,
    isAuthFailed: false,
    catalogue: [],
    user: null,
    token: null,
    isLoginModelOpen: false,
    isUserGuest:
      localStorage.getItem("isGuest") === "true" ||
      localStorage.getItem("guestCart"),
  }),
  mutations: {
    setIsUserGuest(state, isGuest) {
      state.isUserGuest = isGuest;
    },
    setIsLoginModelOpen(state, isOpen) {
      state.isLoginModelOpen = isOpen;
    },
    setCatalogue(state, catalogue) {
      state.catalogue = catalogue;
    },
    setUser(state, user) {
      state.user = user;
      state.isLoggedIn = !!user;
    },
    setToken(state, token) {
      state.token = token;
    },
    setAuthFailed(state, failed) {
      state.isAuthFailed = failed;
    },
  },
  actions: {
    async getCustomerBalance({ state, commit }) {
      try {
        const res = await AuthService.getCustomerBalance();
        if (res) {
          let user = state.user;
          user.Customer.balance = res.data.balance;
          user.Customer.maxBalance = res.data.maxBalance;
          commit("setUser", user);
          // overrite the user object in loocal storage
          localStorage.setItem("user", JSON.stringify(state.user));
        }
        return res;
      } catch (err) {
        console.error("Failed to get customer balance:", err);
        throw err;
      }
    },
    async updateLanguage({ state, commit }, lang) {
      try {
        const res = await AuthService.changeLang({
          phone: state.user.phone,
          language: lang,
        });
        if (res.success) {
          commit("setUser", { ...state.user, language: lang });
        }
        return res;
      } catch (err) {
        console.error("Failed to update language:", err);
        throw err;
      }
    },
    setIsUserGuest(context, isGuest) {
      context.commit("setIsUserGuest", isGuest);
      if (isGuest) {
        localStorage.setItem("isGuest", isGuest);
      } else {
        localStorage.removeItem("isGuest");
      }
    },
    async setUserMailing(context, data) {
      try {
        const res = await AuthService.setUserMailing(data);
        return res;
      } catch (err) {
        console.error("Failed to set mailing:", err);
        throw err;
      }
    },
    async login({ commit }, { token, user }) {
      commit("setToken", token);
      commit("setUser", user);
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
    },
    async tryLogin({ commit, dispatch }) {
      try {
        const token = localStorage.getItem("token");
        const userDetails = JSON.parse(localStorage.getItem("user"));

        if (token && userDetails) {
          commit("setToken", token);
          commit("setUser", userDetails);

          const isUserExpired = await AuthService.isUserExpired();

          await AuthService.getBigData();

          if (isUserExpired?.userTimeOut) {
            console.warn("Failed to get big data, logging out");
            await dispatch("logout");
          }
        }
      } catch (error) {
        console.error("Error during login attempt:", error);
        await dispatch("logout");
        commit("setAuthFailed", true);
      }
    },
    async setLoginModel(context, isOpen) {
      context.commit("setIsLoginModelOpen", isOpen);
    },
    async logout({ commit, dispatch }) {
      commit("setUser", null);
      commit("setToken", null);
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      dispatch("Orders/clearStoreCart", null, { root: true });
    },
  },
  getters: {
    userCustomerAddress: (state) => {
      const address = state.user?.Customer?.address || "";
      const city = state.user?.Customer?.city || "";

      if (address || city) {
        return `${address ? address : "ללא כתובת"}${city ? `, ${city}` : ""}`;
      }

      return "";
    },
    isAdmin: (state) => state.user?.UserRoll?.userroll == "admin",
    isUserGuest: (state, getters) =>
      state.isUserGuest && !getters.isAuthenticated,
    isUserRollFinance: (state) => state.user?.userRoll === "finance",
    getUserCust: (state) => state.user?.Customer?.cust,
    isUserRollNormal: (state) => state.user?.userRoll === "normal",
    getCustomerName: (state) => state.user?.Customer?.custdes,
    getUserLang: (state) => state.user?.language,
    getCustomerData: (state) => state.user?.Customer,
    getCustomerPriceListId: (state) => state.user?.Customer?.priceListId ?? "empty",
    getToken: (state) => state.token,
    getUserName: (state) => state.user?.name,
    getUser: (state) => state.user,
    getUserPhone: (state) => state.user?.phone,
    getUserEmail: (state) => state.user?.email,
    isAuthenticated: (state) => !!state.token,
    isLoginModelOpen: (state) => state.isLoginModelOpen,
  },
};
